
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[user_id]/receipts/[zeipt_receipt_transnr]",
      function () {
        return require("private-next-pages/users/[user_id]/receipts/[zeipt_receipt_transnr].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[user_id]/receipts/[zeipt_receipt_transnr]"])
      });
    }
  